import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-horizontal-header',
  templateUrl: './horizontal-header.component.html',
  styleUrls: ['./horizontal-header.component.css']
})
export class HorizontalHeaderComponent {

    @Output() menuClick = new EventEmitter<void>();

    @Output('onClickViewer') onClickViewerEmitter = new EventEmitter<void>();

}
